import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, } from "react";
import { Menu } from "@headlessui/react";
import { styled } from "../theme";
/**
 * A dropdown menu component.
 *
 * @param {Props} props The props for the component.
 * @returns {JSX.Element} The rendered dropdown menu component.
 */
export const DropdownMenu = ({ trigger, children, closeOnScroll, onOpen, onClose, }) => {
    return (_jsx(Menu, { as: Container, children: ({ close, open }) => (_jsxs(_Fragment, { children: [closeOnScroll ? _jsx(CloseOnScroll, { close: close }) : undefined, _jsx(TrackEvents, { open: open, onOpen: onOpen, onClose: onClose }), _jsx(Menu.Button, { as: "div", children: ({ open }) => trigger(open) }), _jsx(Menu.Items, { as: DropdownMenuStyled, children: children })] })) }));
};
const CloseOnScroll = ({ close, children }) => {
    const handleScroll = () => {
        close();
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll, true);
        return () => window.removeEventListener("scroll", handleScroll, true);
    }, []);
    return _jsx(_Fragment, { children: children });
};
const TrackEvents = ({ open, onOpen, onClose, children }) => {
    const [isOpen, setIsOpen] = useState(open);
    useEffect(() => {
        if (open !== isOpen) {
            setIsOpen(open);
            if (!open && !!onClose)
                onClose();
            if (open && !!onOpen)
                onOpen();
        }
    }, [open]);
    return _jsx(_Fragment, { children: children });
};
export const DropdownMenuStyled = styled.div `
  position: absolute;
  right: 0;
  width: 270px;
  margin-top: 8px;
  padding: 10px;
  max-height: 80vh;
  background-color: ${({ theme }) => theme.color.white};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.color.gray10};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  overflow: auto;
  z-index: 1000;

  a {
    text-decoration: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0px 0px 2px ${({ theme }) => theme.color.primary},
      0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  }
`;
const Container = styled.div `
  display: inline-block;
  position: relative;
`;
